import { FC } from 'react'

import { CustomerLogo } from '@sequencehq/core-components'
import { IntegrationServices } from '@sequencehq/api'

import { getLogo } from 'lib/integrations/logos'
import { INTEGRATIONS_CONFIG } from 'modules/Integrations/integrationsConfig/integrations.config'

export const IntegrationSyncErrorIcon: FC<{
  externalService: string
  size?: number
}> = ({ externalService, size = 16 }) =>
  hasIntegrationLogo(externalService) ? (
    getLogo(externalService, size)
  ) : (
    <CustomerLogo
      size={size}
      data-testid="watchtower.notification.integrationSyncError.fallbackIcon"
    />
  )

const hasIntegrationLogo = (
  externalService: string
): externalService is IntegrationServices =>
  Object.hasOwn(INTEGRATIONS_CONFIG, externalService)
